import React from 'react';
import ReactDOM from 'react-dom';

import './styles/styles.scss';
import App from './App';
import * as Utils from './utils'

const defaultProps = {
  content: {
    th: 'http://www.africau.edu/images/default/sample.pdf',
    en: 'https://www.phoca.cz/demo/phocadownload/phocapdf-demo.pdf'
  },
  defaultLanguage: 'en',
  description: {
    th: 'http://www.africau.edu/images/default/sample.pdf',
    en: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Nostrum repellat asperiores pariatur explicabo expedita sed.'
  },
  modalButton: {
    th: 'button',
    en: 'Privacy Policy'
  },
  acceptButton: {
    th: 'ยอมรับ',
    en: 'i accept'
  },
  
  language: [
    { label: 'En', value: 'en' },
    { label: 'Th', value: 'th' }
  ]
}

export class Init {
  props = {}
  utils = Utils
  constructor(props) {
    // console.log('constructor <<', props);
    const elemDiv = document.createElement('div');
    elemDiv.id = 'root-privacy-policy'
    document.body.appendChild(elemDiv);
    this.props = props;
    this.render();
  }

  render = () => {
    ReactDOM.render(<App {...this.props} />, document.getElementById('root-privacy-policy'));
  }
};

if (process.env.NODE_ENV === 'development') {
  ReactDOM.render(<App {...defaultProps} />, document.getElementById('privacy-policy'));
}





// WEBPACK FOOTER //
// ./src/index.js